// extracted by mini-css-extract-plugin
export default {"ActionMenu_Overlay":"sort-by-menu-module__ActionMenu_Overlay--xm8NY","Box":"sort-by-menu-module__Box--nLYUP","Box_1":"sort-by-menu-module__Box_1--Yc60k"};